import { WORKFLOW_FIELDS } from '../fragments'

export default `
  ${WORKFLOW_FIELDS}
  subscription OnCreateOrUpdateWorkflow($projectId: String!) {
    onCreateOrUpdateWorkflow (projectId: $projectId) {
      ...WorkflowFields
    }
  }
`
